import { createTheme } from "@mui/material/styles";

// --- TYPESCRIPT AUGMENTATION ---
// This tells TS that 'soft' and 'gradient' are valid variants
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    soft: true;
    gradient: true;
  }
}

declare module "@mui/material/Chip" {
  interface ChipPropsVariantOverrides {
    soft: true;
  }
}
// -------------------------------

const bronzeGradient = "linear-gradient(90deg, #C99364 0%, #935C29 100%)";
const contrastGradient = "linear-gradient(90deg, #37474F 0%, #78909C 100%)";
const bronze = "#B87333";
const softBronze = "rgba(184, 115, 51, 0.08)";
const softBronzeHover = "rgba(184, 115, 51, 0.12)";


const theme = createTheme({
  palette: {
    primary: {
      main: "#B87333",
      light: "#C99364",
      dark: "#935C29",
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "99px",
          textTransform: "none",
        },
      },
      variants: [
        {
          props: { variant: "gradient" },
          style: {
            background: bronzeGradient,
            color: "#ffffff",
            transition: "transform 0.2s",
            "&:hover": {
              transform: "translateY(-1px)",
              opacity: 0.95,
            },
          },
        },
        {
          props: { variant: "soft", color: "primary" },
          style: {
            // Using your bronze color with transparency for the "soft" look
            backgroundColor: "rgba(184, 115, 51, 0.12)",
            color: "#935C29", // dark bronze for contrast
            "&:hover": {
              backgroundColor: "rgba(184, 115, 51, 0.25)",
            },
          },
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
        variant: "filled",
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: softBronze,  // #FFE5CC - light peach
          borderRadius: '12px',
          border: '1px solid transparent',
          transition: 'all 0.2s ease-in-out',
          '&:before, &:after': { display: 'none' }, // Remove the bottom underline
          '&:hover': {
            backgroundColor: softBronzeHover,  // #FFDAB3 - slightly darker peach
          },
          '&.Mui-focused': {
            backgroundColor: '#ffffff',
            borderColor: bronze,
            boxShadow: `0 0 0 4px rgba(184, 115, 51, 0.15)`,  // Soft bronze glow
          },
        },
      },
    },
    MuiChip: {
      variants: [
        {
          props: { variant: "soft", color: "primary" },
          style: {
            backgroundColor: "rgba(184, 115, 51, 0.12)",
            color: "#935C29",
            fontWeight: 600,
          },
        },
      ],
    },
  },
});

export default theme;
